import { createAsyncThunk } from '@reduxjs/toolkit'
import { ColumnFiltersState } from '@tanstack/react-table'
import { Axios } from 'api/axios'
import axios from 'axios'
import { count } from 'console'
// import { LoDashStatic } from 'lodash'
const API_URL = process.env.REACT_APP_BASE_URL
const headers = {
  'Content-Type': 'application/json'
}

export interface Organisation {
  id?: number
  packageName: string
  districtCode: string
  districtName: string
  state: string
  status: boolean
  createBy?: string
  updatedBy?: string
  createDate?: string
  updateDate?: string
}
export interface PaginatedResponse<T> {
  count: number
  total_pages: number
  next: string | null
  previous: string | null
  results: T[]
}

export const fetchOrganisation1 = createAsyncThunk(
  'organisation/fetchOrganisation',
  async ({
    page,
    pageSize,
    search,
    sort,
    order,
    filters
  }: {
    page: number
    pageSize: number
    search?: string
    sort?: string
    order?: 'asc' | 'desc' | ''
    filters?: ColumnFiltersState
  }) => {
    try {
      console.log('fetchOrganisation1 called with:', {
        page,
        pageSize,
        search,
        filters
      })
      const token = localStorage.getItem('authToken')
      if (!token) {
        throw new Error('No authentication token found')
      }

      const response: any = await Axios.get(`api/organization/`, {
        params: {
          page,
          page_size: pageSize,
          search: search || undefined,
          filters: filters ? JSON.stringify(filters) : undefined
        }
      })

      const responseData = response.data
      console.log('API response:', responseData)

      return {
        data: responseData?.results || [],
        rowCount: responseData?.count || 0
      }
    } catch (error: any) {
      console.error(
        'fetchOrganisation1 error:',
        error.response?.data || error.message
      )
      throw new Error('Failed to fetch Organisations')
    }
  }
)

export const fetchOrganisations = createAsyncThunk(
  'organisation/fetchOrganisation',
  async ({
    page,
    pageSize,
    sort,
    order,
    search,
    filters
  }: {
    page: number
    pageSize: number
    search?: string
    sort?: string
    order?: 'asc' | 'desc' | ''
    filters?: ColumnFiltersState
  }) => {
    try {
      const params: Record<string, any> = {
        page,
        page_size: pageSize
      }

      if (search) params.search = search?.trim() || "";

      // Build the ordering param for the API
      if (sort) {
        params.ordering = order === 'desc' ? `-${sort}` : sort
      }

      //Add each filter as a query param (e.g. organization_name=...)
      if (filters && Array.isArray(filters)) {
        filters.forEach(filter => {
          const { id, value } = filter
          if (!id || value === undefined || value === '') return
          if ((id === 'updated_at' || id === 'created_at') && typeof value === 'object') {
            const { from_date, to_date } = value as { from_date?: string; to_date?: string }
            if (from_date) params[`${id}_from`] = from_date
            if (to_date) params[`${id}_to`] = to_date
          } else {
            params[id] = value
          }
        })
      }
       if (filters && Array.isArray(filters)) {
        filters.forEach((f: any) => {
          const { id, value } = f
          if (!id || value === undefined || value === '') return

          // Date-range filters: create e.g. created_at_date_from / created_at_date_to
          if ((id === 'updated_at' || id === 'created_at') && value && typeof value === 'object') {
            const dateFilter = value as { from_date?: string; to_date?: string }
            if (dateFilter.from_date) params[`${id}_date_from`] = dateFilter.from_date
            if (dateFilter.to_date) params[`${id}_date_to`] = dateFilter.to_date
            return
          }

          // If value is an object (non-date), flatten as id_key=value (e.g., status_eq=active)
          if (value && typeof value === 'object') {
            Object.entries(value).forEach(([k, v]) => {
              if (v !== undefined && v !== null && v !== '') {
                params[`${id}_${k}`] = v
              }
            })
            return
          }

          // Default scalar filter
          params[id] = value
        })
      }

      const response: any = await Axios.get(`api/organization/`, { params })

      const responseData = response.data
      return {
        data: responseData?.data || responseData?.results || [],
        rowCount: responseData?.count || 0
      }
    } catch (error: any) {
      console.error(
        'fetchOrganisation error:',
        error.response?.data || error.message
      )
      throw new Error('Failed to fetch organisations')
    }
  }
)

export const fetchOrganisationById = createAsyncThunk(
  'organisation/fetchById',
  async (id: string, { rejectWithValue }) => {
    try {
      const response = await Axios.get(`${API_URL}/organisation/${id}/`)
      console.log('resp to update Id : ', response)
      return response
    } catch (err: any) {
      return rejectWithValue(
        err.response?.data || 'Failed to fetch organisations by ID'
      )
    }
  }
)

export const updateOrganisation = createAsyncThunk(
  'organisation/updateOrganisation',
  async (orgData: any) => {
    if (!orgData?.organization_id) throw new Error('Organization ID is required');

    const response = await Axios.patch(
      `${API_URL}api/organization/edit-status/${orgData.organization_id}/`,
      orgData
    );

    return response.data;
  }
);

// export const updateStatusInOrg = createAsyncThunk(
//   'organisation/updateOrganisation2',
//   async (packageData: any) => {
//     console.log('pkgData:', packageData)
//     const response: any = await Axios.patch(
//       `${API_URL}api/organization/edit-status/${packageData.id}/`, 
//       packageData
//     )
//     console.log('updateOrganisation response:', response)
//     return response
//   }
// )
export const updateStatusInOrg = createAsyncThunk(
  'organisation/updateStatusInOrg',
  async (packageData: any) => {
    if (!packageData?.user_id) {
      throw new Error('user_id is required');
    }

    const response = await Axios.patch(
      `api/organization/edit-status/${packageData.user_id}/`, 
      packageData
    );

    return response.data;
  }
);

export const addOrganisation = createAsyncThunk(
  'organisation/addOrganisation',
  async (packageData: any) => {
    // const token = localStorage.getItem("authToken");
    // if (!token) {
    //   throw new Error("No authentication token found");
    // }

    const response = await Axios.post(`${API_URL}/organisation/`, packageData)
    console.log('addOrganisation response:', response)
    console.log('addOrganisation response:', response.data)
    return response.data
  }
)

export const deleteOrganisation = createAsyncThunk(
  'packages/delete',
  async (id: number, { rejectWithValue }) => {
    try {
      await axios.delete(`${API_URL}/${id}`, { headers })
      return id
    } catch (err: any) {
      console.error('Delete error:', err)
      return rejectWithValue(err.response?.data?.message || err.message)
    }
  }
)
export const fetchOrganisationColumnFilter = createAsyncThunk(
  'organisation/fetchOrganisationColumnFilter',
  async (column: string, { rejectWithValue }) => {
    try {
      const response = await Axios.get(
        `${API_URL}api/organization/column-filter-dropdown/`,
        { params: { column_filter: column } }
      );
      const data = response.data;

      console.log('Thunk payload:', {
        column,
        values: data[column] || [],
      });


      return {
        column,
        values: data[column] || [],
      };
    } catch (err: any) {
      console.error('fetchOrganisationColumnFilter error:', err);
      return rejectWithValue(
        err.response?.data || 'Failed to fetch column filter values'
      );
    }
  }
);

//Exports csv file
// Exports department CSV file
export const exportOrganisationsCSV = createAsyncThunk(
  'department/exportCSV',
  async (_, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("authToken");
      const headers = {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
        'Accept': '*/*'
      };
      const response = await Axios.get(
        '/organization/?export=excel',
        { headers, responseType: 'blob' }
      );
      return {
        blob: response.data,
        filename:
          response.headers['content-disposition']
            ?.split('filename=')[1]
            ?.replace(/"/g, '') || 'organisations.csv'
      };
    } catch (err: any) {
      console.error('Export CSV error:', err);
      return rejectWithValue(err.message || 'Failed to export CSV');
    }
  }
);

export const OrganisationsExportsCSV = async ({
  search,
  filters,
}: {
  search?: string;
  filters?: any;
}) => {
  const params = new URLSearchParams();
  params.append("export", "excel");

  if (search) params.append("search", search);

  if (filters && filters.length > 0) {
    filters.forEach(({ id, value }: { id: string; value: any }) => {
      if (id && value !== undefined && value !== null) {
        if (typeof value === "object" && value !== null) {
          const maybeDateFilter = value as {
            from_date?: string;
            to_date?: string;
          };

          if (
            (maybeDateFilter.from_date || maybeDateFilter.to_date) &&
            (id === "created_at" || id === "updated_at")
          ) {
            if (maybeDateFilter.from_date) {
              params.append(`${id}_from`, maybeDateFilter.from_date);
            }
            if (maybeDateFilter.to_date) {
              params.append(`${id}_to`, maybeDateFilter.to_date);
            }
            return;
          }

          // Other object filters
          Object.entries(value).forEach(([key, val]) => {
            if (val !== undefined && val !== null && val !== "") {
              params.append(key, String(val));
            }
          });
        } else {
          params.append(id, value);
        }
      }
    });
  }

  const response = await Axios.get(`/organization/?${params.toString()}`, {
    responseType: "blob",
  });

  return {
    blob: response.data,
    filename:
      response.headers["content-disposition"]
        ?.split("filename=")[1]
        ?.replace(/"/g, "") || "Organisation.csv",
  };
};

